/**
 * Painted occupancy of a desk or park place on the floor plan.
 */
export enum PlaceVariant {
  /** Free for the selected window. Green circle. */
  AVAILABLE = "available",
  /** Fully covering the selected window. Red circle. */
  OCCUPIED = "occupied",
  /** Overlap that does not cover the full window. Half green / half red pie. */
  PARTIAL = "partial",
  /** Tandem partner constraint. Green circle with red diagonal slash; not selectable. */
  BLOCKED = "blocked",
  /** Inactive / grey. */
  WEAK = "weak",
  /** Not permitted. Grey. */
  FORBIDDEN = "forbidden",
  /** Filter miss among bookable desks. Yellow. */
  TEMP = "temp"
}
